import React, { useEffect } from 'react';
import { useStore } from '../../../stores/root';
import { faHome } from '@fortawesome/pro-light-svg-icons';
import { Stack } from '@fluentui/react';
import NewsForm from '../../../components/settings/news/general/form';
import { useParams } from 'react-router-dom';
import PermissionsService from '../../../services/permissions';
import NoAccess from '../../../components/uiframeworks/noAccess';

type TypeUpdateNewsPageProps = {
  children?: React.ReactNode;
};

const UpdateNewsPage: React.FC<TypeUpdateNewsPageProps> = (props) => {
  const { topbar, user } = useStore();
  const params: any = useParams();

  useEffect(() => {
    topbar.show("Update News", [
      { key: "home", icon: faHome, href: "/" },
      { key: "settings", text: 'Settings', href: "/settings" },
      { key: "news", text: 'Public News', href: "/settings/news" },
      { key: "update", text: 'Update News' }
    ])
  }, []);

  const hasPermission = PermissionsService.hasPermission(['news.create'], user.permissions);

  return (
    <Stack>
      {hasPermission ? <NewsForm newsId={params.newsId} /> : <NoAccess />}
    </Stack>
  );
};

export default UpdateNewsPage;
